import { safelyParseDate } from '@/utils/date';
import { createDisplayFieldPicker } from '@/utils/rowCacheSync';

const normalizeClientDate = (value) => {
	const parsed = safelyParseDate(value);
	return parsed ? parsed.toISOString() : value;
};

/** Picks client/prospect list grid display fields from a cached getClientRow entry. */
export const pickClientDisplayFieldsFromCache = createDisplayFieldPicker({
	name: 'present',
	contactName: 'present',
	contactEmail: 'present',
	contactPhone: 'present',
	brokerGroupId: 'present',
	referralPartner: 'nullable',
	lifeInsuranceReferralStatus: 'nullable',
	kiwiSaverReferralStatus: 'nullable',
	isProspect: 'present',
	stage: 'present',
	prospectAmount: 'present',
	insightId: 'present',
	ownerDocId: 'truthy',
	ownerId: 'truthy',
	nextTaskDate: { transform: normalizeClientDate },
	createdDate: { transform: normalizeClientDate },
});
